// extracted by mini-css-extract-plugin
export default {"dateRangePickerStyles":"dateRangePickerStyles_BnGH8","textalignRight":"textalignRight_jckJX","textalignLeft":"textalignLeft_Vt4Vb","textalignCenter":"textalignCenter_UUPvl"};